import { ColDef } from '@ag-grid-enterprise/all-modules'
import i18n from '@/lang/i18n'
import { initialCrudModelBaseState, CrudModelPaginatorLaboratory } from '@/shared/models/cruds.models'
import { ConfigurationAssaygroupLaboratoryResponse } from '@/modules/configurationModule/detail/local-assays/assaygroups-laboratory/services/configuration-assaygroup-laboratory/configuration-assaygroup-laboratory.dto'
import { configurationAssaygroupLaboratoryService } from '@/modules/configurationModule/detail/local-assays/assaygroups-laboratory/services/configuration-assaygroup-laboratory/configuration-assaygroup-laboratory.service'
import { PaginatorLaboratoryDatasource } from '@/shared/resources/datasources/paginator/paginator-laboratory-datasource'
import { AgGridColumnType } from '@/shared/models/ag-grid.model'
import { store } from '@/store/store'

export const columnsDefLocalAssaysAssaygroupsLaboratoryGrid =
    (): ColDef[] => [
        { type: AgGridColumnType.CUSTOM_CHECKBOX },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.sections.assayGroup'),
            field: 'assaygroup.name',
            minWidth: 400,
            flex: 1,
            suppressSizeToFit: true,
            sortable: false
        },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.grid.localName'),
            field: 'name',
            minWidth: 400,
            flex: 1,
            suppressSizeToFit: true,
            sortable: false
        }
    ]

export interface ConfigurationLocalAssaysAssaygroupsLaboratoryGridState extends CrudModelPaginatorLaboratory<ConfigurationAssaygroupLaboratoryResponse> {
    service: typeof configurationAssaygroupLaboratoryService
    laboratoryId: number
}
export const initialConfigurationLocalAssaysAssaygroupsLaboratoryGridState =
    (): ConfigurationLocalAssaysAssaygroupsLaboratoryGridState => ({
        ...initialCrudModelBaseState(),
        gridUiComponent: 'uicomponent.configuration.local.assays.assaysGroups',
        columnsDef: columnsDefLocalAssaysAssaygroupsLaboratoryGrid(),
        datasource: new PaginatorLaboratoryDatasource(configurationAssaygroupLaboratoryService, store.getters.labId),
        service: configurationAssaygroupLaboratoryService,
        laboratoryId: store.getters.labId
    })
